package com.tixforgigs.common.ui.components.mandarin

import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.core.enums.MandarinCheckboxType
import com.tixforgigs.common.core.models.ui.InputState
import com.tixforgigs.common.core.util.IdHelper.generateRandomId
import com.tixforgigs.tarami.AraiMessage.inputCheckboxResalePrivateLabel
import io.kvision.core.AlignItems
import io.kvision.core.Container
import io.kvision.core.JustifyContent
import io.kvision.event.changeFlow
import io.kvision.html.label
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.checkbox.checkbox
import io.kvision.material.widget.TouchTarget
import io.kvision.panel.hPanel
import io.kvision.state.bind
import io.kvision.utils.perc
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update

@OptIn(ExperimentalMaterialApi::class)
fun Container.mandarinCheckbox(
  state: MutableStateFlow<InputState<Boolean>>,
  checkboxType: MandarinCheckboxType,
  onClick: suspend () -> Unit = {}
) {
  val checkboxId = generateRandomId(numbersAllowed = false)
  hPanel(
    justify = JustifyContent.START,
    alignItems = AlignItems.CENTER,
  ) {
    height = 100.perc

    checkbox {
      id = checkboxId
      touchTarget = TouchTarget.Wrapper
    }.bind(state) { state ->
      checked = state.inputValue
    }.changeFlow.onEach {
      state.update { it.copy(inputValue = it.inputValue.not(), isValid = true) }
      onClick()
    }.launchIn(MainScope())

    label(
      forId = checkboxId,
    ) {
      +when (checkboxType) {
        MandarinCheckboxType.PRIVATE_RESALE -> inputCheckboxResalePrivateLabel()
        @MissingTaramiMessageKey
        MandarinCheckboxType.TEMPLATE_CONFIG_SEARCH_ENABLED -> "Suche aktivieren"

        @MissingTaramiMessageKey
        MandarinCheckboxType.TEMPLATE_CONFIG_DETAIL_DESCRIPTION_ENABLED -> "Detailansicht aktivieren"
      }
    }
  }
}